export default __webpack_public_path__ + "static/media/aboutimage.b332db0b.svg";